import React from 'react';
import ProductSidebarComponent from './ProductSidebarComponent';
import { PageHeader } from '../../components';

const RoAntiscalants: React.FC = () => {
  return (
    <>
      <PageHeader title="RO Antiscalants – SANYOL® WT Series" breadcrumbs={[{ label: "Products", path: "/products" }]} />

      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s"
        style={{ visibility: "visible", animationDelay: "0.1s", animationName: "fadeInUp" }}>
        <div className="container">
          <div className="row g-5">

            <div className="col-lg-8">
              <div className="row g-3 mb-5">
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-3.jpg" alt="" />
                </div>
                <div className="col-md-6">
                  <img className="img-fluid" src="img/industrial-1.jpg" alt="" />
                </div>
              </div>
              <h1 className="mb-4">RO Antiscalants – SANYOL® WT Series</h1>
              
              <h3 className="mb-4">Overview</h3>
              <p>Reverse Osmosis (RO) Antiscalants are critical for ensuring smooth, long-term operation of RO membranes by preventing scale formation from hardness, silica, and metal salts. At Wasser Technochem (India) Ltd., our SANYOL® WT Antiscalants are specifically engineered to suit Indian water conditions across textile, power, pharma, and industrial sectors.</p>
              <p>Formulated using premium-quality polymers and phosphonates, our range is compatible with all leading membrane brands (Veolia, DOW, Hydranautics, Toray, etc.) and is ideal for high-recovery RO systems.</p>

              <h3 className="mb-4">Applications</h3>
              <p><i className="fa fa-industry text-primary me-2"></i>Industrial RO systems (Process & Boiler feed)</p>
              <p><i className="fa fa-building text-primary me-2"></i>Commercial RO units (Hospitals, Hotels, Institutions)</p>
              <p><i className="fa fa-recycle text-primary me-2"></i>ZLD plants with multi-stage RO</p>
              <p><i className="fa fa-ship text-primary me-2"></i>Sea Water RO and Brackish Water RO</p>
              <p><i className="fa fa-flask text-primary me-2"></i>RO in textile dyeing, pharma, and power industries</p>

              <h3 className="mb-4">Product Range (SANYOL® WT)</h3>
              <p><i className="fa fa-circle text-secondary me-2"></i><strong>SANYOL® WT 1200/1201</strong> – General purpose high-performance</p>
              <p><i className="fa fa-circle text-secondary me-2"></i><strong>SANYOL® WT 1202</strong> – High TDS and Silica control</p>
              <p><i className="fa fa-circle text-secondary me-2"></i><strong>SANYOL® WT 1203</strong> – For Brackish & Sea Water RO</p>
              <p><i className="fa fa-circle text-secondary me-2"></i><strong>SANYOL® WT 7901/7902</strong> – Acidic & Alkaline membrane cleaners for CIP</p>

              <h3 className="mb-4">Features & Benefits</h3>
              <p><i className="fa fa-check-circle text-success me-2"></i>Controls CaCO₃, CaSO₄, BaSO₄, SrSO₄, Silica scaling</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Compatible with polyamide and TFC membranes</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Effective over wide pH (5–9) and TDS ranges</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Reduces CIP frequency and membrane replacement</p>
              <p><i className="fa fa-check-circle text-success me-2"></i>Liquid formulation – easy to dose and mix</p>

              <h3 className="mb-4">Why WTIL?</h3>
              <p><i className="fa fa-star text-warning me-2"></i>Large automated manufacturing facility</p>
              <p><i className="fa fa-star text-warning me-2"></i>In-house R&D tailored to local water profiles and tailored formulations</p>
              <p><i className="fa fa-star text-warning me-2"></i>Customized dosing support & antiscalant selection</p>
              <p><i className="fa fa-star text-warning me-2"></i>Technical backup with membrane performance monitoring</p>
              <p><i className="fa fa-star text-warning me-2"></i>Trusted by leading cement, textile, and chemical industries</p>
              <p className="mb-5"><i className="fa fa-star text-warning me-2"></i>Supply across India with ready stock availability</p>
            </div>

            <div className="col-lg-4">
              <ProductSidebarComponent />
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default RoAntiscalants;
